<template>
  <div class="col-md-12">
    <div class="col-md-12 breadcumb" style="padding-top: 20px">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/principal' }"
          >Home</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <el-divider></el-divider>
    <div class="col-md-12">
      <h4 slot="header" class="card-title text-purple">
        {{ $t("app.modules.customers.billing") }}
      </h4>
      <div class="col.md-12">
        <el-collapse accordion>
          <el-collapse-item
            name="1"
            :title="$t('app.general.search')"
            class="col-12"
          >
            <div class="col-md-12 row d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="col-md-4">
                <fg-input>
                  <el-input
                    type="search"
                    class="mb-2"
                    clearable
                    prefix-icon="el-icon-search "
                    style="width: 200px"
                    :placeholder="$t('app.modules.orders.headers.order_number')"
                    v-model="searchNumber"
                    aria-controls="datatables"
                  >
                  </el-input>
                </fg-input>
              </div>
              <div class="col-md-4">
                {{ $t("app.general.start_date") }}
                <fg-input>
                  <el-date-picker
                    type="date"
                    placeholder="Date Picker"
                    v-model="iniDate"
                  >
                  </el-date-picker>
                </fg-input>
              </div>
              <div class="col-md-4">
                {{ $t("app.general.end_date") }}
                <fg-input>
                  <el-date-picker
                    type="date"
                    placeholder="Date Picker"
                    v-model="endDate"
                  >
                  </el-date-picker>
                </fg-input>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="col-md-12">
        <div class="row">
          <el-table stripe style="width: 100%" :data="queriedData">
            <el-table-column
              prop="idClienteSAP"
              :label="this.$t('app.modules.customers.client_code_SAP')"
              :min-width="280"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="numeroPedidoSAP"
              :label="this.$t('app.modules.orders.headers.order_number')"
              :min-width="250"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="fecha"
              :label="this.$t('app.general.date')"
              :min-width="250"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="numeroFactura"
              :label="this.$t('app.modules.orders.headers.bill_number')"
              :min-width="250"
              sortable
            >
            </el-table-column>
            <el-table-column :min-width="100" className="is-center">
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="100"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="openSendBill(props.row.idFactura)"
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{ $t("app.general.send") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    style="background-color: white"
                  >
                    <i class="fa fa-ellipsis-v" style="color: black"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            {{ $t("app.pagination.showing") }} {{ from + 1 }}
            {{ $t("app.pagination.of") }} {{ to }}
            {{ $t("app.pagination.of") }} {{ total }}
            {{ $t("app.pagination.records") }}
          </p>
        </div>

        <n-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </n-pagination>
      </div>
    </div>
    <send-bill />
  </div>
</template>

<script>
export default {
  components: {
    SendBill: () => import("../components/facturasEnvio"),
  },
  data() {
    return {
      bills: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: "",
      emails: [],
      item: {
        id: 0,
        emails: [],
      },
      searchNumber: "",
      iniDate: new Date(new Date().getFullYear(), 0, 1),
      endDate: new Date(new Date().getFullYear(), 11, 1),
    };
  },
  computed: {
    queriedData() {
      let result = this.applyFilters(this.bills);
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      let searchedData = this.applyFilters(this.bills);
      return searchedData.length > 0 ? searchedData.length : this.bills.length;
    },
  },
  async mounted() {
    this.tableData = [];
    this.$swal.fire({
      title: this.$t("app.promps.wait"),
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false,
    });

    await this.getBills();
    await this.getEmails();

    this.$swal.close();
  },
  methods: {
    async getBills() {
      var payload = {
        id: this.$store.state.user.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("FacturacionCliente/getFacturasCliente"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.bills = response.body.facturas;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async getEmails() {
      var payload = {
        id: this.$store.state.user.idClienteSAP,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
      };

      await this.$http
        .post(route("FacturacionCliente/getEmailsClient"), payload)
        .then(
          async (response) => {
            if (response.body.code === 200) {
              this.emails = response.body.correos;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          (error) => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    openSendBill(id) {
      this.item.id = id;
      this.item.emails = this.emails;
      EventBus.$emit("send-bill", this.item);
    },
    applyFilters(result) {
      // filter by search number
      result =
        this.searchNumber.length > 0
          ? result.filter((f) =>
              f.numeroPedidoSAP.toString().includes(this.searchNumber)
            )
          : result;

      // filter by date
      result =
        this.iniDate > new Date("1900-01-01") &&
        this.endDate > new Date("1900-01-01") &&
        this.iniDate instanceof Date &&
        this.endDate instanceof Date
          ? (result = result.filter(
              (f) =>
                new Date(f.fecha) >= this.iniDate &&
                new Date(f.fecha) <= this.endDate
            ))
          : result;

      return result;
    },
  },
};
</script>

<style scoped>

.searchbox{
  color: white !important;
}

</style>
